import equipmentScheduleOrderPageActions from './equipmentScheduleOrderPageActions';
import { getOptions } from 'helpers/getOptions';
import $api from 'http/index';
import equipmentPageActions from './equipmentPageActions';


export const fetchEquipmentColorGroupsAndOrder =
  ({ allLocations = false, tenantLocationId = null } = {}) =>
  async (dispatch) => {
    const options = {
      ...getOptions(),
      params: {},
    };

    if (allLocations) {
      options.params.allLocations = true;
    }

    if (tenantLocationId) {
      options.params.tenantLocationId = tenantLocationId;
    }

    try {
      const response = await $api.get(
        `${process.env.REACT_APP_BASE_URL}/equipment/color-groups-and-order`,
        options
      );

      dispatch(
        equipmentScheduleOrderPageActions.getEquipmentScheduleOrdersData(response.data)
      );
    } catch (error) {
      dispatch(equipmentScheduleOrderPageActions.equipmentScheduleOrdersError(error));
    }
  };


export const patchEquipmentOrder = (equipmentId, color, orderInColorGroup, tenantLocationId = null) => async (dispatch) => {
  const options = getOptions();

  const body = {
    color,
    orderInColorGroup,
    tenantLocationId,
  };

  try {
    const response = await $api.patch(
      `${process.env.REACT_APP_BASE_URL}/equipment/${equipmentId}/order`,
      body,
      options
    );

    dispatch(
      equipmentScheduleOrderPageActions.updateEquipmentScheduleOrder(response.data)
    );
    if (response.data?.equipment) {
      dispatch(equipmentPageActions.updateEquipment(response.data.equipment))
    }
  } catch (error) {
    dispatch(equipmentScheduleOrderPageActions.equipmentScheduleOrdersError(error));
  }
};

export const patchEquipmentColorGroupOrder = (groupId, orderNumber, tenantLocationId = null) => async (dispatch) => {
  const options = getOptions();

  const body = {
    orderNumber,
    tenantLocationId,
  };

  try {
    const response = await $api.patch(
      `${process.env.REACT_APP_BASE_URL}/equipment-color-groups/${groupId}/order`,
      body,
      options
    );

    dispatch(
      equipmentScheduleOrderPageActions.updateEquipmentGroupsOrdersData(response.data)
    );
  } catch (error) {
    dispatch(equipmentScheduleOrderPageActions.equipmentScheduleOrdersError(error));
  }
};
